import { createUrlParameters } from '@comeon/utility';

function sendJson(url, data, httpMethod) {
	const headers = new Headers();
	const API_BASE_PATH = process.env.API_BASE_PATH || '';

	headers.append('Content-Type', 'application/json');
	const options = {
		headers,
		method: httpMethod,
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: JSON.stringify(data)
	};

	return fetch(`${API_BASE_PATH}${url}`, options)
		.then(response => {
			if (response.status === 204) {
				return undefined;
			}

			return response.json();
		})
		.catch(e => {
			// eslint-disable-next-line no-console
			console.log(`${e} for ${httpMethod} ${url}`);

			return Promise.reject(e);
		});
}
function postJson(url, data) {
	return sendJson(url, data, 'POST');
}

function postFile(url, file, credentials) {
	const form = new FormData();
	form.append('file', file);
	if (credentials) {
		form.append('credentials', JSON.stringify(credentials));
	}
	const options = {
		method: 'POST',
		credentials: 'include',
		body: form
	};
	return fetch(url, options)
		.then(response => (response.status === 413 ? response.status : response.json()))
		.catch(e => {
			return Promise.reject(e);
		});
}

function putJson(url, data) {
	return sendJson(url, data, 'PUT');
}

function postFormUrlEncoded(url, urlEncodedData) {
	const headers = new Headers();
	headers.append('Content-Type', 'application/x-www-form-urlencoded');

	const options = {
		headers,
		method: 'POST',
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: urlEncodedData
	};
	return fetch(url, options)
		.then(response => response.json())
		.catch(e => {
			// eslint-disable-next-line no-console
			console.log(`Post url-encoded form failed. url=${url}, options=${urlEncodedData}, error:`, e);
			return Promise.reject(e);
		});
}

function getUrl(url, data) {
	const API_BASE_PATH = process.env.API_BASE_PATH || '';
	if (data === undefined) {
		return `${API_BASE_PATH}${url}`;
	}
	return `${API_BASE_PATH}${url}?${createUrlParameters(data)}`;
}

function postObjectAsFormUrlEncoded(url, data) {
	return postFormUrlEncoded(url, createUrlParameters(data));
}

function fetchJson(url, data) {
	const headers = new Headers();
	headers.append('accept', 'application/json');
	const options = {
		headers,
		method: 'GET',
		credentials: 'include',
		cache: 'no-store'
	};

	return fetch(getUrl(url, data), options).then(response => {
		if (response.ok) {
			return response.json();
		}
		if (response.status === 404) {
			return {};
		}
		return { message: response };
	});
}

export { fetchJson, postFormUrlEncoded, postJson, postFile, postObjectAsFormUrlEncoded, putJson };
